import RepairHistoryView from './containers/RepairHistoryView';

import React from 'react';

export default RepairHistoryView;

export {serverDataRepairHistory} from './reducers/RepairHistoryView';